import { mapActions } from 'vuex';

const SnackbarMixin = {
  methods: {
    ...mapActions('snackbar', ['snackbarShow', 'snackbarError', 'snackbarSuccess', 'snackbarWarning']),
  },
};

export default SnackbarMixin;
